import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import {
  IsoDateSelectorComponent,
  NgCommonModule,
} from '@principle-theorem/ng-shared';
import * as moment from 'moment-timezone';
import { AccDiagnosisDetailsFormGroup } from '../../form-groups/acc-dental-diagnosis.formgroup';
import { AccEmploymentFormGroup } from '../../form-groups/acc-employment.formgroup';
import {
  AccAssistanceFormGroup,
  AccInjuryFormGroup,
} from '../../form-groups/acc-injury.formgroup';
import { AccPatientReferenceFormGroup } from '../../form-groups/acc-patient-referance.formgroup';
import { AccPatientFormGroup } from '../../form-groups/acc-patient.formgroup';
import { AccReferralManagementFormGroup } from '../../form-groups/acc-referrals.formgroup';
import { AccSummaryDeclarationFormGroup } from '../../form-groups/acc-summary-declaration.formgroup';
import { AccWorkCapacityFormGroup } from '../../form-groups/acc-work-capacity.formgroup';
import { AccFormSummaryComponent } from '../acc-form-summary/acc-form-summary.component';

@Component({
  selector: 'pr-acc-summary-declaration-form',
  imports: [NgCommonModule, IsoDateSelectorComponent, AccFormSummaryComponent],
  templateUrl: './acc-summary-declaration-form.component.html',
  styleUrls: ['./acc-summary-declaration-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccSummaryDeclarationFormComponent {
  form = input.required<AccSummaryDeclarationFormGroup>();

  patientReferenceForm = input.required<AccPatientReferenceFormGroup>();
  patientForm = input.required<AccPatientFormGroup>();
  injuryForm = input.required<AccInjuryFormGroup>();
  employmentForm = input.required<AccEmploymentFormGroup>();
  workCapacityForm = input.required<AccWorkCapacityFormGroup>();
  dentalDiagnosisForm = input.required<AccDiagnosisDetailsFormGroup>();
  referralForm = input.required<AccReferralManagementFormGroup>();
  assistanceForm = input.required<AccAssistanceFormGroup>();

  editStep = output<number>();

  min = moment().startOf('day');

  onEditStep(stepIndex: number): void {
    this.editStep.emit(stepIndex);
  }
}
